<template>
  <list-affiliations-results :context="context" v-model="affiliations" :biblio="biblio"
                             :nbEstimateAffiliation="nbEstimateAffiliation"
                             :nbAffiliations="localAllAffiliations.length"
                             :changeSort="changeSort"
                             :listType="listType"/>
</template>

<script>
import Filters from './../filter/Filters'
import ListAffiliationsResults from './ListAffiliationsResults'

export default {
  components: {
    ListAffiliationsResults,
    Filters
  },
  props: ['allAuthors', 'type', 'listId', 'authorsSelected', 'authorsSimilar', 'context',
    'biblio', 'nbEstimateAffiliation', 'searchState', 'listType', 'searchType', 'project'],
  name: 'ListAffiliations',
  data () {
    return {
      localAllAuthors: [],
      localAllAffiliations: [],
      affiliations: [],
      sort: {
        col: 'nbDocuments',
        order: 'desc'
      }
    }
  },
  watch: {
    'context.affiliationsSelected': function () {
      this.initAffiliations()
    },
    'context.countriesSelected': function () {
      this.initAffiliations()
    },
    'context.pubDateSelected': function () {
      this.initAffiliations()
    },
    allAuthors: function (val) {
      this.localAllAuthors = val
    },
    localAllAuthors: function (val) {
      if (val.length !== 0) {
        this.getAllAffiliations(val)
      }
    },
    localAllAffiliations: function (val) {
      if (val.length !== 0 && this.listId !== null) {
        this.initAffiliations()
      }
    },
    companyAuthorsSelected: function () {
      this.identifySelectedAndSimilarAuthors(this.affiliations)
    },
    'biblio.content': function (content) {
      this.setSelectedDocumentInBiblio()
    }
  },
  methods: {
    setSelectedDocumentInBiblio: function () {
      if (this.biblio !== null && typeof this.biblio.content !== 'undefined') {
        let content = JSON.parse(this.biblio.content)
        let documentsId = {}
        documentsId = this.getDocumentSelectedInBiblio(content)

        this.affiliations.forEach((affiliation) => {
          let documentsUpdated = false

          let documents = affiliation.docs.map((document) => {
            let wasBilbio = document.biblio
            document.biblio = documentsId[document.documentID] === true

            if ((typeof wasBilbio === 'undefined' && document.biblio === true) ||
                (typeof wasBilbio !== 'undefined' && wasBilbio !== document.biblio)) {
              documentsUpdated = true
            }
            return document
          })

          if (documentsUpdated) {
            affiliation.docs = documents
          }
        })

        this.affiliations = Object.assign([], this.affiliations)
      }
    },
    getDocumentSelectedInBiblio: function (nodes) {
      let documentsId = {}

      for (let keyNode in nodes) {
        if (!nodes.hasOwnProperty(keyNode)) { continue }
        if (typeof nodes[keyNode]['documents'] !== 'undefined') {
          for (let documentKey in nodes[keyNode]['documents']) {
            if (!nodes[keyNode]['documents'].hasOwnProperty(documentKey)) { continue }
            documentsId[nodes[keyNode]['documents'][documentKey]['id']] = true
          }
        }
      }
      return documentsId
    },
    getAllAffiliations: function (authors) {
      let affiliations = {}

      let seDocumentTitle = [
        'Primary Domain',
        'Publications',
        'Training',
        'Influence',
        'Edison Since'
      ]

      let authorsById = {}
      authors.forEach((author) => {
        authorsById[author.authorID] = author
      })


      authors.forEach((author) => {
        if (typeof author.affiliation !== 'undefined') {
          let organisationId = author.affiliation.organisationID
          if (typeof affiliations[organisationId] === 'undefined') {
            affiliations[organisationId] = author.affiliation
            affiliations[organisationId].docs = {}
          }

          author.docs.forEach((document) => {
            if (typeof affiliations[organisationId].docs[document.documentID] === 'undefined') {
              if (seDocumentTitle.indexOf(document.title) === -1) {
                document.co_authors = document.co_authors.map((coAuthor) => {
                  if (typeof authorsById[coAuthor.authorID] !== 'undefined') {
                    return authorsById[coAuthor.authorID]
                  }
                })
                affiliations[organisationId].docs[document.documentID] = document
              }
            }
          })
        }
      })

      let allAffiliations = []
      for (let affiliationId in affiliations) {
        if (!affiliations.hasOwnProperty(affiliationId)) {
          continue
        }

        let tmpDocs = []
        for (let documentId in affiliations[affiliationId].docs) {
          if (!affiliations[affiliationId].docs.hasOwnProperty(documentId)) {
            continue
          }
          tmpDocs.push(affiliations[affiliationId].docs[documentId])
        }

        tmpDocs.sort((document1, document2) => {
          let date1 = new Date(document2.pubDate).getFullYear()
          let date2 = new Date(document1.pubDate).getFullYear()

          if (this.sort.order === 'desc') {
            return date1 - date2
          } else if (this.sort.order === 'asc') {
            return date2 - date1
          }
        })
        affiliations[affiliationId].docs = tmpDocs

        allAffiliations.push(affiliations[affiliationId])
      }
      if (typeof this.searchType !== 'undefined' && this.searchType !== null && this.searchType.type === 'Name') {
        this.localAllAffiliations = this.filterByName(allAffiliations)
      } else {
        this.localAllAffiliations = allAffiliations
      }
    },
    initAffiliations: function () {
      let affiliations = Object.assign([], this.localAllAffiliations)

      if (this.context.affiliationsSelected.length === 0 && this.context.countriesSelected.length === 0 &&
          this.context.pubDateSelected.length === 0) {
        this.context.filterSelected = null
      } else {
        if ((this.context.affiliationsSelected.length === 0 && this.context.filterSelected === 'affiliation') ||
            (this.context.countriesSelected.length === 0 && this.context.filterSelected === 'country') ||
            (this.context.pubDateSelected.length === 0 && this.context.filterSelected === 'pubDate')) {
          this.context.filterSelected = null
          this.initFilters(affiliations)
        }

        if (this.context.filterSelected === null) {
          if (this.context.affiliationsSelected.length > 0) {
            this.context.filterSelected = 'affiliation'
          }
          if (this.context.countriesSelected.length > 0) {
            this.context.filterSelected = 'country'
          }
          if (this.context.pubDateSelected.length > 0) {
            this.context.filterSelected = 'pubDate'
          }
        }
      }
      affiliations = this.applyFilters(affiliations)

      this.initFilters(affiliations)

      affiliations = this.applyFilters(affiliations)

      this.applySort(affiliations)

      this.identifySelectedAndSimilarAuthors(affiliations)
    },
    initFilters: function (affiliations) {
      let pubDateFilter = []
      let affiliationsFilter = []
      let countriesFilter = []

      affiliations.forEach((affiliation) => {
        if (typeof affiliationsFilter[affiliation.organisationID] === 'undefined') {
          affiliationsFilter[affiliation.organisationID] = {
            nb: 1,
            name: affiliation.organisationName,
            id: affiliation.organisationID,
            country: affiliation.country
          }
        } else {
          ++affiliationsFilter[affiliation.organisationID].nb
        }

        let country = countriesFilter.find((element) => {
          return element.name === affiliation.country
        })

        if (typeof country === 'undefined') {
          countriesFilter.push({nb: 1, name: affiliation.country})
        } else {
          ++country.nb
        }

        affiliation.docs.forEach((document) => {
          let date = new Date(document.pubDate).getFullYear()

          let year = pubDateFilter.find((element) => {
            return element.name === date
          })

          if (typeof year === 'undefined') {
            pubDateFilter.push({nb: 1, name: date})
          } else {
            ++year.nb
          }
        })
      })

      pubDateFilter.sort((date1, date2) => {
        return parseInt(date2.name) - parseInt(date1.name)
      })
      affiliationsFilter.sort((affiliation1, affiliation2) => {
        return parseInt(affiliation2.nb) - parseInt(affiliation1.nb)
      })

      if (this.context.filterSelected !== 'affiliation') {
        this.context.affiliationsFilter = affiliationsFilter
      }
      if (this.context.filterSelected !== 'country') {
        this.context.countriesFilter = countriesFilter
      }
      if (this.context.filterSelected !== 'year' && this.context.pubDateSelected.length === 0) {
        this.context.pubDateFilter = pubDateFilter
      }

      if (this.context.filterSelected === null) {
        this.context.affiliationsFilter = affiliationsFilter
        this.context.countriesFilter = countriesFilter
        this.context.pubDateFilter = pubDateFilter
      }
      this.$emit('updatePubDate', this.context.pubDateFilter)
      this.$emit('updateCountries', {
        'countries': this.context.countriesFilter,
        'companies': this.context.affiliationsFilter
      })
    },
    applyFilters: function (affiliations) {
      if (this.context.filterSelected !== null &&
          (this.context.affiliationsSelected.length > 0 || this.context.countriesSelected.length > 0 ||
            this.context.pubDateSelected.length > 0)) {
        affiliations = affiliations.filter((affiliation) => {
          let affiliationFilterByAffiliation = true
          let affiliationFilterByCountry = true
          let affiliationFilterByPubDate = true

          this.context.affiliationsSelected.map((affiliationSelected) => {
            if (affiliation.organisationID === affiliationSelected.id) {
              affiliationFilterByAffiliation = false
            }
          })

          this.context.countriesSelected.map((country) => {
            if (affiliation.country === country.name) {
              affiliationFilterByCountry = false
            }
          })

          let yearFound = false
          this.context.pubDateSelected.map((year) => {
            affiliation.docs.map((document) => {
              let date = new Date(document.pubDate)
              if (date.getFullYear() === year.name) {
                yearFound = true
              }
            })
            if (yearFound === true) {
              affiliationFilterByPubDate = false
            }
          })

          let affiliationFilter = true
          if (affiliationFilterByAffiliation === false || affiliationFilterByCountry === false ||
              affiliationFilterByPubDate === false) {
            affiliationFilter = false
            if (this.context.affiliationsSelected.length > 0 && affiliationFilter === false) {
              affiliationFilter = affiliationFilterByAffiliation
            }
            if (this.context.countriesSelected.length > 0 && affiliationFilter === false) {
              affiliationFilter = affiliationFilterByCountry
            }
            if (this.context.pubDateSelected.length > 0 && affiliationFilter === false) {
              affiliationFilter = affiliationFilterByPubDate
            }
          }

          return !affiliationFilter
        })
      }
      return affiliations
    },
    applySort: function (affiliations) {
      switch (this.sort.col) {
        case 'nbDocuments':
          affiliations.sort((affiliation1, affiliation2) => {
            if (this.sort.order === 'desc') {
              return affiliation2.docs.length - affiliation1.docs.length
            } else if (this.sort.order === 'asc') {
              return affiliation1.docs.length - affiliation2.docs.length
            }
          })
          break
        case 'country':
          affiliations.sort((affiliation1, affiliation2) => {
            let country1 = typeof affiliation1.country === 'undefined' ? 'zzzzz' : affiliation1.country
            let country2 = typeof affiliation2.country === 'undefined' ? 'zzzzz' : affiliation2.country

            if (this.sort.order === 'desc') {
              return country2.toLowerCase() < country1.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return country1.toLowerCase() < country2.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'affiliation':
          affiliations.sort((affiliation1, affiliation2) => {
            let name1 = typeof affiliation1.organisationName === 'undefined'
              ? 'zzzzz' : affiliation1.organisationName
            let name2 = typeof affiliation2.organisationName === 'undefined'
              ? 'zzzzz' : affiliation2.organisationName

            if (this.sort.order === 'desc') {
              return name2.toLowerCase() < name1.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return name1.toLowerCase() < name2.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'pubDate':
          affiliations.sort((affiliation1, affiliation2) => {
            let document1 = affiliation1.docs[0]
            let document2 = affiliation2.docs[0]

            let date1 = new Date(document2.pubDate).getFullYear()
            let date2 = new Date(document1.pubDate).getFullYear()

            if (this.sort.order === 'desc') {
              return date1 - date2
            } else if (this.sort.order === 'asc') {
              return date2 - date1
            }
          })
          break
      }
    },
    identifySelectedAndSimilarAuthors: function (affiliations) {
      if (typeof this.authorsSelected !== 'undefined' && this.authorsSelected !== null &&
          typeof this.authorsSimilar !== 'undefined' && this.authorsSimilar !== null) {
        affiliations.forEach((affiliation) => {
          affiliation.docs.forEach((document) => {
            document.co_authors.forEach((author) => {
              author.selected = false
              author.similar = false
              this.authorsSelected.forEach((authorSelected) => {
                if (authorSelected.authorID === author.authorID) {
                  author.selected = true
                }
              })

              this.authorsSimilar.forEach((authorSimilar) => {
                if (authorSimilar.authorID === author.authorID) {
                  author.similar = true
                }
              })
            })
          })
        })
      }
      this.affiliations = Object.assign([], affiliations)

      this.setSelectedDocumentInBiblio()
    },
    filterByName: function (affiliations) {
      affiliations = affiliations.map((affiliation) => {
        affiliation.docs = affiliation.docs.filter((document) => {
          let foundAuthor = document.co_authors.find((author) => {
            return author.lastName.toLowerCase() === this.searchType.lastName.toLowerCase()
          })
          return typeof foundAuthor !== 'undefined'
        })
        return affiliation
      })
      return affiliations
    },
    changeSort: function (col) {
      this.sort.col = col
      this.sort.order = (this.sort.order === 'desc' ? 'asc' : 'desc')
      this.applySort(this.affiliations)
    }
  },
  beforeMount () {
    this.localAllAuthors = this.allAuthors
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAffiliations/ListAffiliations.vue